import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import { EntityLink } from "~/components/entity-link";
import type { homeStoryPackageTailContentItemContent$key } from "~/queries/__generated__/homeStoryPackageTailContentItemContent.graphql";

import { ActionBarContainer, Container, HeadlineContainer } from "./styles";

type Props = {
  reference: homeStoryPackageTailContentItemContent$key;
} & ContentItemRenderVariantProps;

export const ContentItemHomeStoryPackageTail = forwardRef<HTMLDivElement, Props>(
  ({ className, onClick, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment homeStoryPackageTailContentItemContent on Content {
          ...entityLink
          entityId
        }
      `,
      reference_,
    );

    return (
      <Container className={className} ref={reference}>
        <EntityLink reference={content} onClick={() => onClick?.(content.entityId)}>
          <HeadlineContainer>
            {provider.headline({
              preferSocialHeadline: true,
              skipHighlight: true,
            })}
          </HeadlineContainer>
        </EntityLink>
        <ActionBarContainer>
          {provider.actionBar({
            isBookmarkVisible: false,
            isCommentsVisible: true,
          })}
        </ActionBarContainer>
      </Container>
    );
  },
);

ContentItemHomeStoryPackageTail.displayName = "ContentItemHomeStoryPackageTail";
